import { type Carer, type CarerRole, Responsibility } from '@lmc/ts-common'

export const getCarerRole = (role: CarerRole) => {
  switch (role) {
    case 'carehome-admin':
      return 'Admin'
    case 'carer':
      return 'Carer'
    case 'family':
      return 'Family'
    case 'group-admin':
      return 'Group Admin'
    case 'group-manager':
      return 'Group Manager'
    case 'lmc-admin':
      return 'Lmc Admin'
    case 'senior-carer':
      return 'Senior Carer'
    default:
      return ''
  }
}

export const matchesSearchGroups = (
  item: Carer,
  statuses: string[],
  search: string
) => {
  const fullName = `${item.name?.first} ${item.name?.last}`

  const hasStatusesSelected = !!statuses?.length

  const isCarerActive = item.active

  return (
    !!fullName.match(
      new RegExp(
        (search as string).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'),
        'i'
      )
    ) &&
    (hasStatusesSelected
      ? statuses.includes(isCarerActive ? 'active' : 'inactive')
      : true)
  )
}

export const matchesSearch = (
  item: Carer,
  roles: string[],
  statuses: string[],
  search: string
) => {
  const fullName = `${item.name?.first} ${item.name?.last}`

  const hasRolesSelected = !!roles?.length

  const hasStatusesSelected = !!statuses?.length

  const isCarerActive = item.active

  const hasSafeguardingOfficerRole = roles.includes('safeguarding-officer')
  const hasSafeguardingPermission = item.permissions?.includes(
    Responsibility.SafeguardingOfficer
  )

  const matchesRoleFilter = !hasRolesSelected
    ? true
    : roles.includes(item.role) ||
      (hasSafeguardingOfficerRole && hasSafeguardingPermission)

  return (
    !!fullName.match(
      new RegExp(
        (search as string).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'),
        'i'
      )
    ) &&
    matchesRoleFilter &&
    (hasStatusesSelected
      ? statuses.includes(isCarerActive ? 'active' : 'inactive')
      : true)
  )
}
